import { Icon, Tooltip } from '@snapchat/snap-design-system-marketing';
import type { FC } from 'react';

import { copyToClipboard } from '../utils/copyToClipboard';
import {
  actionButtonCss,
  actionButtonIconNudgeCss,
  messageActionsCss,
} from './MessageActions.styles';

interface MessageActionsProps {
  id: string;
  content: string;
  allowRedo?: boolean;
  onRedo?: () => void;
}

export const MessageActions: FC<MessageActionsProps> = ({ id, content, allowRedo, onRedo }) => (
  <div className={messageActionsCss}>
    <Tooltip uniqueId={`${id}-copy`} content="Copy" place="bottom">
      <button
        className={actionButtonCss}
        type="button"
        aria-label="Copy"
        onClick={() => void copyToClipboard(content)}
      >
        <Icon className={actionButtonIconNudgeCss} name="copy" size={16} />
      </button>
    </Tooltip>
    {allowRedo && (
      <Tooltip uniqueId={`${id}-redo`} content="Redo" place="bottom">
        <button className={actionButtonCss} type="button" aria-label="Redo" onClick={onRedo}>
          <Icon name="refresh" size={16} />
        </button>
      </Tooltip>
    )}
  </div>
);

MessageActions.displayName = 'MessageActions';
